import { createResourceModule } from '../../../lib/resource/module.js';
import { propertyDetail } from './schemas.js';

/**
 * The Properties module's API layer.
 *
 * The six CRUD paths and their hooks come from the shared factory; the four
 * reference vocabularies are the module's own, because a property is written in
 * codes — `AUD`, `AU`, `VIC`, `MEL` — that no other module shares.
 *
 * The reference paths carry their query string rather than taking an argument,
 * because they are also cache keys: the same path always means the same request.
 */
export const properties = createResourceModule({
  resource: 'properties',
  basePath: '/v1/properties',
  detail: propertyDetail,
});

export const propertyEndpoints = {
  ...properties.endpoints,
  // Reference data moved out of property-service: geography and ISO 4217 are
  // not property concerns, and two read paths over one table drift.
  //
  // `limit=250` is the options maximum. The country list is 249 rows and the
  // picker searches server-side through `?q=`, so a form never needs the
  // whole table in one response.
  currencies: '/v1/currencies/options?limit=250',
  countries: '/v1/countries/options?limit=250',
  states: (countryCode: string): string =>
    `/v1/states/options?countryCode=${encodeURIComponent(countryCode)}&limit=250`,
  cities: (countryCode: string, stateCode: string): string =>
    `/v1/cities/options?countryCode=${encodeURIComponent(countryCode)}&stateCode=${encodeURIComponent(stateCode)}&limit=250`,
} as const;
